import React from "react";
import { BadgeProps, BadgeVariant } from "./Badge.types";
import { cn } from "@/utils/cn";

const base = "inline-flex items-center justify-center text-xs font-medium px-2.5 py-1 rounded";

const variants: Record<BadgeVariant, string> = {
    default: "bg-gray-100 text-gray-950 dark:bg-gray-700 dark:text-white rounded-full",
    primary: "bg-primary-300 text-primary-950 dark:bg-primary-500 dark:text-white rounded-full",
    secondary: "bg-secondary-300 text-secondary-950 dark:bg-secondary-500 dark:text-white rounded-full",
    success: "bg-green-100 text-green-950 dark:bg-green-700 dark:text-white rounded-full",
    error: "bg-red-100 text-red-950 dark:bg-red-700 dark:text-white rounded-full",
    warning: "bg-yellow-100 text-yellow-950 dark:bg-yellow-700 dark:text-white rounded-full",
    info: "bg-blue-100 text-blue-950 dark:bg-blue-700 dark:text-white rounded-full",
    darkInfo: "bg-blue-700 text-white dark:bg-blue-700 dark:text-white rounded-full",
    darkError: "bg-red-700 text-white dark:bg-red-700 dark:text-white rounded-full",
};

export const Badge: React.FC<BadgeProps> = ({
    children,
    variant = "default",
    className,
}) => {
    return (
        <span className={cn(base, variants[variant], className)}>
            {children}
        </span>
    );
};
